module.exports = __webpack_public_path__ + "static/media/icon.a0a912e8.svg";